export const WidgetMap = new Map([
    [1, 'flatFeeAcRem'],
    [2, 'acWaitingtoMove'],
    [3, 'daysSincePlacmentofAc'],
    [4, 'placementHistoryofMonthAc'],
    [5, 'ageImpactofonAcResolution'],
    [6, 'unReadNotifications']
  ]);